module.exports = __webpack_public_path__ + "static/kaye-ann-9ec573d83b0b1ecc2ae1172ff30f56cd.png";